import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    no: {
        id: 'iaso.polio.label.no',
        defaultMessage: 'No',
    },
    yes: {
        id: 'iaso.polio.label.yes',
        defaultMessage: 'Yes',
    },
    confirmDeleteNopv2Auth: {
        id: 'iaso.polio.label.confirmDeleteNopv2Auth',
        defaultMessage:
            'Do you want to delete this nOPV2 vaccine authorisation?',
    },
    deleteNopv2Auth: {
        id: 'iaso.polio.label.deleteNopv2Auth',
        defaultMessage: 'Delete  authorisation',
    },
});

export default MESSAGES;
